import styled from 'styled-components';

export const DatePickerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  background: white;
`;
